<groundworks-card title="{{ title() }}" [isCollapsible]="true">
  <groundworks-card-body>
    @switch (getState()) { @case ('loading') {
    <groundworks-state-message type="loading" [message]="'Loading ' + title() + '...'" class="d-flex mt-5" />
    } @case ('no-matches') {
    <groundworks-state-message type="no-matches" [message]="'No ' + title() + ' Found.'" class="d-flex mt-5" />
    } @case ('error') {
    <groundworks-state-message type="error" [message]="'Error loading ' + title() + '.'" class="d-flex mt-5" />
    } @case ('matches') {
    <div class="row g-3 mb-3">
      <div [class]="'col-md-' + layoutColumns()[0]">
        <app-appointment-history [appointments]="appointments()" [isDisabled]="hasSale()"
          [showRemoveFromFollowUpButton]="showRemoveButton()" [isPendingSale]="isPendingSale()"
          (scheduleRevisitClick)="onScheduleRevisitClick()" (removeFromFollowUpClick)="onRemoveFromFollowUpClick()"
          (appointmentCreated)="onAppointmentCreated($event)" (dispositionUpdated)="onDispositionUpdated()" />
      </div>
      @if (showChecklist()) {
      <div [class]="'col-md-' + layoutColumns()[1]">
        <app-sales-approval-checklist [quote]="quote()" [opportunityId]="opportunityId()"
          [canSaleBeApproved]="canSaleBeApproved()"
          [completedSaleApprovalItems]="getCompletedItems()"
          [systemVerifiedSaleApprovalItems]="getSystemVerifiedItems()"
          (completedSaleApprovalItemsChange)="onCompletedItemsChange($event)" (saleCreated)="onSaleCreated($event)" />
      </div>
      }
    </div>
    } }
  </groundworks-card-body>
</groundworks-card>
